import { AsyncImage } from "loadable-image";
import { getServiceIcon } from "src/commun/utils/iconUtils";
import React from "react";
import { useAppState } from "src/app/state/StateProvider";

export type AppAsyncImageProps = {
  serviceCode: string;
} & React.ComponentProps<"img">;

const AppAsyncImage = ({ serviceCode, ...props }: AppAsyncImageProps) => {

  const [state] = useAppState();

  return (
    state.menu?.imageBaseURl &&
      <AsyncImage
        src={getServiceIcon(state.menu?.imageBaseURl, serviceCode)}
        style={{ width: 50, height: 50 }}
        loader={<div style={{ background: '#FFF' }}/>}
        {...props}
      />
  );
};

export default AppAsyncImage;
